import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgXTwitter = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M13.8113 10.3152L21.8258 1H19.9264L12.968 9.08867L7.41025 1H1L9.404 13.2311L1 23H2.89933L10.2473 14.4585L16.1168 23H22.527L13.8113 10.3152ZM11.2108 13.3393L10.3592 12.121L3.58317 2.43H6.5L11.9679 10.251L12.8195 11.4692L19.9273 21.6351H17.0105L11.2108 13.3393Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgXTwitter);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const XTwitter = Memo;
export { XTwitter as default };
